
<button
  [type]="type"
  class="{{class}}"
  [id]="id"
  [style.width]="themeConfig?.width" [style.height]="themeConfig?.height" [style.background]="themeConfig?.borderColor" [style.padding]="themeConfig?.borderSize" [style.box-shadow]="themeConfig?.boxShadow" [style.border-radius]="themeConfig?.borderRadius" [style.opacity]="disabled?'0.5':'1'"
  [disabled]="disabled || loading"
  (click)="btnClicked.emit($event)">
  <div *ngIf="!loading"
    [style.font-size]="themeConfig?.fontSize" [style.font-family]="themeConfig?.fontFamily" [style.color]="themeConfig?.textColor" [style.background]="themeConfig?.bgColor" [style.letter-spacing]="themeConfig?.letterSpacing">
    <em *ngIf="preIcon" class="material-icons">{{preIcon}}</em> <span [innerHTML]="label"></span> <em *ngIf="postIcon" class="material-icons">{{postIcon}}</em>
  </div>
  <div *ngIf="loading" class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
</button>
